import styled from 'styled-components'

export const ContentContainer = styled.div<{ $widgetHeight: number }>`
  margin-top: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 2px;
  height: ${({ $widgetHeight }) => {
    if ($widgetHeight < 300) return '100%'
    return 'auto'
  }};
`
